import { connect } from 'react-redux'
import { compose, withHandlers, withProps } from 'recompose'
import { bindActionCreators } from 'redux'

import * as SegmentSelectors from 'app/modules/segment/selectors'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import { ConditionType, AudienceDisplay } from 'app/modules/playbook/constants'
import { isOnFreePlan } from 'app/modules/gates/selectors'

import withOrgTeams from 'app/modules/teams/hoc/withOrgTeams'

import ConditionPreview from './component'

const mapStateToProps = (state, props) => ({
  condition: PlaybookSelectors.getCondition(state, props),
  segments: SegmentSelectors.segments(state, props),
  isOnFreePlan: isOnFreePlan(state),
  isOutboundPlaybook: PlaybookSelectors.isOutboundPlaybook(state),
  getPlaybookIdForCampaignId: campaignId => PlaybookSelectors.playbookIdForCampaignId(state, campaignId),
  getIsPlaybookIdForCampaignIdLoading: campaignId =>
    PlaybookSelectors.playbookIdForCampaignIdLoading(state, campaignId),
  playbooks: PlaybookSelectors.playbooks(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      deleteCondition: PlaybookActions.deleteCondition,
      showConditionModal: PlaybookActions.showConditionModal,
      getPlaybookByCampaignId: PlaybookActions.getPlaybookByCampaignId,
      getPlaybookByCampaignIdPending: PlaybookActions.getPlaybookByCampaignIdPending,
    },
    dispatch
  ),
})

export default compose(
  withOrgTeams,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    getSegmentNames: displayValues =>
      displayValues
        .map(value => {
          const segment = props.segments.find(segment => segment.get('id') === value)
          if (segment) {
            return segment.get('name')
          } else {
            return AudienceDisplay[value]
          }
        })
        .filter(Boolean),
    isSegment: props.condition.field === ConditionType.SEGMENT,
    isTeamCondition: props.condition.field === ConditionType.TEAM_AVAILABILITY,
    isOutboundSessionCondition: props.condition.field === ConditionType.OUTBOUND_SESSION,
    isEmailPlaybookCondition:
      props.condition.field === ConditionType.URL_QUERY &&
      props.condition.value.some(v => v && v.startsWith && v.startsWith('d_campaign')),
  })),
  withProps(props => {
    if (props.isEmailPlaybookCondition) {
      try {
        const campaignId = parseInt(props.condition.value.first().split('=')[1])
        const selectedPlaybookId = props.getPlaybookIdForCampaignId(campaignId)
        if (!selectedPlaybookId && campaignId && !props.getIsPlaybookIdForCampaignIdLoading(campaignId)) {
          props.actions.getPlaybookByCampaignId({ campaignId })
          props.actions.getPlaybookByCampaignIdPending({ campaignId })
        } else if (selectedPlaybookId) {
          return {
            selectedPlaybookId,
          }
        }
      } catch(err) {
        return {}
      }
    }
    return {}
  }),
  withHandlers({
    onDeleteClick: ({ id, actions: { deleteCondition }}) => () => {
      deleteCondition(id)
    },
    onEditClick: ({ id, actions: { showConditionModal }}) => () => {
      showConditionModal(id)
    },
  })
)(ConditionPreview)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ConditionPreview/index.js